import { i18n } from '@shared/i18n';
import { GenericModel } from '@shared/model/generic-model';
import BooleanField from '@shared/fields/boolean-field';
import StringField from '@shared/fields/string-field';
import FilesField from '@shared/fields/files-field';

function label(name) {
    return i18n(`entities.subprogram.fields.additionalDoc.${name}`);
}

const fields = {
    exist: new BooleanField('exist', label('exist'), { required: true }),
    text: new StringField('text', label('text'), { required: true }),
    title: new String('title', label('title'), { required: true }),
    requiredDocs: new FilesField( 
        'requiredDocs',
        label('requiredDocs'),
        ({subpropertyId, programId, subprogramId}) => `subproperties/${subpropertyId}/programs/${programId}/subprograms/${subprogramId}/additionalDocs`,
        { /*max: 10,*/ required: true },
    ),
}

export class SubprogramAdditionalDocModel extends GenericModel {
    static get fields() {
        return fields;
    }
}